module.exports = __webpack_public_path__ + "sn.svg?c1a6798abc4a04fd81139f968d305a8c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/sn.svg
// module id = 1364
// module chunks = 0